(function () {
  'use strict';

  var focusableSelector = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    'summary:not([tabindex="-1"])',
    '[role="button"]:not([aria-disabled="true"]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function visibleFocusable(container) {
    return Array.prototype.filter.call(container.querySelectorAll(focusableSelector), function (element) {
      return element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden';
    });
  }

  function containTab(event, container) {
    if (event.key !== 'Tab') return;
    var items = visibleFocusable(container);
    if (!items.length) {
      event.preventDefault();
      container.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function prefersReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function focusTarget(target) {
    if (!target) return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  window.CygnaxisA11y = {
    focusables: visibleFocusable,
    containTab: containTab,
    prefersReducedMotion: prefersReducedMotion,
    motionBehavior: function () { return prefersReducedMotion() ? 'auto' : 'smooth'; },
    focusTarget: focusTarget,
    announce: function (message) {
      var status = document.getElementById('A11yStatus');
      if (!status) return;
      status.textContent = '';
      window.setTimeout(function () { status.textContent = message; }, 30);
    }
  };

  function enhance(root) {
    root = root || document;

    root.querySelectorAll('button:not([type])').forEach(function (button) {
      if (!button.closest('form') || !button.matches('[type="submit"]')) button.type = 'button';
    });

    root.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') < 0) rel.push('noopener');
      if (rel.indexOf('noreferrer') < 0) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
      if (!link.querySelector('.a11y-new-window')) {
        var note = document.createElement('span');
        note.className = 'a11y-new-window';
        note.textContent = ' (opens in a new tab)';
        link.appendChild(note);
      }
    });

    root.querySelectorAll('img:not([alt])').forEach(function (image) {
      image.alt = '';
    });

    root.querySelectorAll('[role="button"]').forEach(function (control) {
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      if (control.dataset.a11yKeyReady) return;
      control.dataset.a11yKeyReady = 'true';
      control.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && control.getAttribute('aria-disabled') !== 'true') {
          event.preventDefault();
          control.click();
        }
      });
    });
  }

  enhance(document);
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
})();
